import React from 'react';
import Basket from '../basket';
import './header.css';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <div className="header">
      <div className="row d-flex align-items-center justify-content-between">
        <div className="col-sm-8 col-7 d-flex align-items-center">
          <Link to="/re-store" className="title_link">
            <h3 className="store-title">ReStore</h3>
          </Link>
          <ul className="menu-store d-flex ">
            <li>
              <Link to="/re-store/cart">Cart</Link>
            </li>
          </ul>
        </div>
        <div className="col-md-3 col-sm-4 col-5">
          <Link
            to="/re-store/cart"
            className="basket_link d-flex justify-content-end"
          >
            <Basket />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
